// extracted by mini-css-extract-plugin
module.exports = {"projectStyles":"styles_projectStyles__3-Xvn","contentStyles":"styles_contentStyles__1qlT9","video":"styles_video__2TA98"};